import styled, { css } from 'styled-components';
import { colors } from '../../../../styles/colors';
import Tooltip from '../../tooltips/TooltipButton';
import { rowAnimantion } from '../../../../styles/keyframes';

interface ICellProps {
    isAutomatic?: boolean;
    className: string;
    header?: boolean;
    key?: number;
}

interface ITRow {
    index?: number;
    displayItem?: boolean;
}

interface IExclusionToolTip {
    disabled?: boolean;
}
export const TableDnD = styled.div`
    display: flex;
    width: 100%;
    flex-flow: column;
    flex: 1 1;
`;

export const Table = styled.div`
    display: flex;
    flex-flow: column;
    flex: 1 1;
    width: 100%;
    border-radius: 10px 10px 0px 0px;
    margin-right: 5px;
    box-sizing: border-box;
    background-color: #FFFFFF;

    font-size: calc(10.25px + 0.12vw) !important;

    position: relative;
    overflow-y: auto;
    
    p{
        font-size: inherit;
    }

    .header{
        height: 36px;
        box-sizing:border-box;
        display:flex;
        text-align: left;
        border-radius: 10px 10px 0px 0px;
        font-weight: bold;

        div {
            background:  ${colors.greenDarkViveo};
        }

        p{
            color:  ${colors.white};
        }

        img{
            margin-left: 6.4px;   
        }
    }

    .body{
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing:border-box;
        min-height: 100px;
        
        > div {
                &:first-child > div > div {
                border-top: none;
            }
        }
    }
`;

export const Row = styled.div` 
    position: relative;
    display: flex;
    flex-flow: column;
    width: 100%;
    box-sizing: border-box;
    animation: ${rowAnimantion} 1s ease-out;

    .icon{
        transition: all 1s ease-in;
        img{
            display: none;
        }
    }
`;

export const TRow = styled.div<ITRow>`
    display: flex;
    width: 100%;
    box-sizing:border-box;
    position: relative;
    font-weight: ${props => props.index === 0 && 'bold'};
`;

export const TDRow = styled(TRow)` 
    > div {
        background-color: ${props => props.className === 'isCustomer' ? '#E3E3E3' : props.displayItem ? '#fff' : '#ECECEC'};
        border-bottom: ${props => props.className === 'isCustomer' ? '0' : '1px solid rgba(133,133,133,0.4)'};
        border-top: ${props => props.className === 'isCustomer' ? '10px solid #f2f2f2' : '0'};
    }

    ${props => !props.displayItem && css`
        > div > p {
            color: #858585;
        }
    `}

    &.hide-border-quote-item {
        > div {
            border-bottom: 0;
        }
    }
`;

export const Cell = styled.div<ICellProps>`    
    display: flex;
    align-items: center;
    flex: 1 0;
    min-height: ${props => props.header ? '36px' : props.isAutomatic ? '80px' : '50px'};
    max-height: 80px;
    padding: 0 12.8px;
    box-sizing:border-box;

    p {
        width:100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;  
    }

    &.icon{
        flex: 1 1;
        justify-content: center;

        img{
            width: 15px;
            max-width: 15px !important;
            margin: 2px 0 0 0;
        }
    }

    &.quoteItem {
        max-height: none;
        border-bottom: 0;
    }

    &.blockMessage {
        width: 670px;
        padding-left: 12.8px;
    }

    &.isCustomer {
        min-width: 50px;
        padding-left: 18px;
    }

    &.sequenceNumber{
        justify-content: center;
        word-wrap: auto;
        min-width: 75px;
    }
    &.statusIcon{
        margin-left: -10px;
    }
    &.id{
        min-width: 90px;
    }
    
    &.description {
        min-width: 290px;
        .descriptionText{
            white-space: nowrap;
                overflow: hidden;
            p {
                text-overflow: ellipsis;  
            }

            .activeIngredient{
                color: #858585;
                font-size: 12px !important;
            }
        }
    }

    &.brand, &.producer{
        min-width: 150px;
    }

    &.unit{
        min-width: 140px;
    }

    &.conversionFactor{
        min-width: 120px;
        gap: 5px;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .subtitle{
            font-weight: 700;
            color: ${colors.greenDarkViveo};
        }

        input {
            height: 26px;
        }
    }

    &.quantity {
        min-width: 120px;
        height: auto !important;
    }

    &.actionBtn{
        min-width: 130px;
    }

    &.tagsMedicineTipe{
        min-width: 190px;
        display: flex;
        justify-content: center;

        .tagsComponents{   
            width: 150px;
            height: 65px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: unset;
        }
    }

    &.actions{
        min-width: 130px;
        display: flex;
        flex-direction: row;
        justify-content: left;
        padding: 0 12.8px;
    }

    &.portifolioContainer{
        min-width: 130px;
    }  

    .trashIcon{
        cursor: pointer;
    }
`;

export const FooterIndicatorsContainer = styled.div`
  display: flex;
  gap: 11.2px;

  & > * {
    flex: none;
  }
`;

export const ExclusionToolTip = styled(Tooltip).attrs<IExclusionToolTip>(({ disabled, origin }) => ({
    text: `Item não enviado para ${origin}`,
    bottom: "40px",
    left: "-40px",
    width: "124px",
    color: "#364863",
    disable: disabled
}))``;
